import { ApplicationInsights } from "@microsoft/applicationinsights-web";

const connectionString = process.env.REACT_APP_APPLICATIONINSIGHTS_CONNECTION_STRING;

// Without a connection string (e.g. local `npm start` without a .env, or a deploy
// target where the app setting hasn't been configured yet) the SDK throws on
// initialize() instead of no-op'ing, which crashes the whole app. Fall back to a stub
// with the same trackEvent surface so every call site keeps working either way.
const appInsights = connectionString
  ? new ApplicationInsights({
      config: {
        connectionString,
        enableAutoRouteTracking: true,
      },
    })
  : { trackEvent: () => {} };

if (connectionString) {
  appInsights.loadAppInsights();
} else {
  console.warn(
    "REACT_APP_APPLICATIONINSIGHTS_CONNECTION_STRING is not set — Application Insights tracking is disabled."
  );
}

export default appInsights;
